import { Page } from "@/models/page-models/Page";

export const SparePartsTransferRequests: Page = {
  "path": "spare-parts-transfer-requests",
  "name": "Pending Spare Parts Requests",
  "props": {
    "data": {
      "title": "Pending Spare Parts Requests",
      "printable": "FALSE",
      "url": "spare-parts-transfer-requests",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Pending Transfer Requests",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.transfers}}",
                  "items": "fetchedData.transfers.data",
                  "headers": [
                    {
                      "value": "sparePart._id",
                      "text": "Spare Part #"
                    },
                    {
                      "value": "sparePart.description",
                      "text": "Description"
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity",
                      "filterType": "unit",
                      "filterParam": "{{__item.sparePart.unit}}"
                    },
                    {
                      "value": "location",
                      "text": "Location",
                      "type": "formula",
                      "formula": "{{__item.locationFrom}} -> {{__item.locationTo}}"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "selectableUniqueId": "_id",
                  "groupActions": [
                    {
                      "label": "Approve Transfer",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "name": "approveSparePartTransfer"
                        }
                      ]
                    }
                  ],
                  "singleSelect": false,
                  "neverHideActionBar": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPendingSparePartsTransfers"
      }
    ],
    "functions": [
      {
        "name": "getPendingSparePartsTransfers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/spareparts/transfer/pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.transfers"
      },
      {
        "name": "approveSparePartTransfer",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/spareparts/transfer/{{__item._id}}/approve",
        "arg2Key": "refreshPage",
        "arg2Value": "TRUE"
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": false
}